/**
 * The upload rules the API publishes (GET /catalogue/upload-rules, ORD-06), loaded once and shared:
 * the same size and types the upload itself checks, with the server's defaults until they load.
 */

import { useQuery } from "@tanstack/react-query";

import { getUploadRules } from "../api/catalogue";
import { SUPPORT_FILES_PER_MESSAGE, SUPPORT_UPLOAD_RULE, type UploadRule } from "./uploadRules";

/** What a support message's attachments accept, and how many it may carry (SUP-10). */
export function useSupportUploadRule(): { rule: UploadRule; perMessage: number } {
  const { data } = useQuery({ queryKey: ["upload-rules"], queryFn: getUploadRules, staleTime: Infinity });
  return {
    rule: data?.support_attachment ?? SUPPORT_UPLOAD_RULE,
    perMessage: data?.support_attachments_per_message ?? SUPPORT_FILES_PER_MESSAGE,
  };
}
